import { createContext, useContext, useState } from "react";
import { translations } from "../i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState("sq");

    const t = (key) => {
        return translations[lang]?.[key] || translations["en"]?.[key] || key;
    };

    const toggleLang = () => setLang(l => l === "sq" ? "en" : "sq");

    return (
        <LangContext.Provider value={{ lang, setLang, t, toggleLang }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);
